import { LeadFilters } from '@shared/features/views/components/entities-filters/leads';
import { SubmissionFilters } from '@shared/features/views/components/entities-filters/submissions';
import { TaskFilters } from '@shared/features/views/components/entities-filters/tasks';
import { ProgramFilters } from '@shared/features/views/components/entities-filters/programs';
import { StageFilters } from '@shared/features/views/components/entities-filters/stages';
import { InvoiceFilters } from '@shared/features/views/components/entities-filters/invoices';
import { PaymentFilters } from '@shared/features/views/components/entities-filters/payments';
import { ProductFilters } from '@shared/features/views/components/entities-filters/products';

import { useTiclickTableContext } from '@src/design-system/molecules/ticlick-table/context/ticlick-table-context-hook';

import { VIEW_ENTITIES, type TView } from '@shared/types/view';

const ENTITIES_FILTERS_MAPPER: Partial<
  Record<TView['entity_type'], () => JSX.Element>
> = {
  [VIEW_ENTITIES.task]: TaskFilters,
  [VIEW_ENTITIES.lead]: LeadFilters,
  [VIEW_ENTITIES.application]: SubmissionFilters,
  [VIEW_ENTITIES.program]: ProgramFilters,
  [VIEW_ENTITIES.stage]: StageFilters,
  [VIEW_ENTITIES.invoice]: InvoiceFilters,
  [VIEW_ENTITIES.payment]: PaymentFilters,
  [VIEW_ENTITIES.product]: ProductFilters,
};

export function FiltersPopoverContent() {
  const { table } = useTiclickTableContext();

  const tableViewEntity = table.options.meta?.identifyingData.viewEntityType;

  const EntityFilters = ENTITIES_FILTERS_MAPPER[tableViewEntity!];

  return (
    <div className='flex flex-col'>
      <div className='space-y-4'>{EntityFilters && <EntityFilters />}</div>
    </div>
  );
}
